export default __webpack_public_path__ + "static/media/project-ss.efe22a6f.png";